import '../../../../assets/item-remove.css';
import { jsx as o } from "react/jsx-runtime";
import { faXmark as c } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon as n } from "@fortawesome/react-fontawesome";
import a from "clsx";
import { forwardRef as i } from "react";
const l = "_remove_1q7dc_1", p = {
  remove: l
}, f = i((e, r) => {
  const { className: m, children: t, ...s } = e;
  return /* @__PURE__ */ o("button", { ...s, ref: r, tabIndex: -1, className: a(m, p.remove), children: t ?? /* @__PURE__ */ o(n, { icon: c }) });
});
f.displayName = "Combobox.Trigger.ValueMultiple.Item.Remove";
export {
  f as ItemRemove
};
